// extracted by mini-css-extract-plugin
export var actions = "_1e-0";
export var actionsContainer = "_1e-7";
export var border = "_1e-1";
export var childFullHeight = "_1e-e";
export var collapse = "_1e-2";
export var content = "_1e-9";
export var contentChild = "_1e-d";
export var fullscreen = "_1e-b";
export var hasLeftRadius = "_1e-q";
export var headerContainer = "_1e-3";
export var headerRow = "_1e-5";
export var hidePadding = "_1e-a";
export var navCollapsedGap = "_1e-r";
export var noScrollX = "_1e-s";
export var noScrollY = "_1e-t";
export var noTopPadding = "_1e-o";
export var optOutTopPadding = "_1e-c";
export var outletContent = "_1e-k";
export var outletContentInner = "_1e-l";
export var outletLeadingPanel = "_1e-h";
export var outletLeadingPanelAttention = "_1e-i";
export var outletResizeDivider = "_1e-j";
export var outletSplit = "_1e-f";
export var outletSplitResizing = "_1e-g";
export var pageMain = "_1e-p";
export var pageOuter = "_1e-m";
export var pagePadding = "_1e-8";
export var profile = "_1e-u";
export var profileContainer = "_1e-v";
export var profileImage = "_1e-w";
export var profileMain = "_1e-x";
export var profileSubtitle = "_1e-z";
export var profileTitle = "_1e-y";
export var showLeftPadding = "_1e-n";
export var tabsPortalSlot = "_1e-6";
export var tabsWrapper = "_1e-4";
export var title = "_1e-10";